<template>
  <div class="recruit-detail">
    <div v-if="imgPath" class="top-banner">
      <van-image :src="imgPath">
        <template v-slot:error>加载失败</template>
      </van-image>
    </div>
    <div class="position-list-wrap">
      <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
        <van-list
          v-if="(list && list.length) || loading"
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad">
          <position v-for="(item,index) in list" :key="index" :position="item"></position>
        </van-list>
        <no-data v-else></no-data>
      </van-pull-refresh>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .top-banner{
    width: 100%;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .position-list-wrap{
    width: 100%;
    background-color: #f5f5f5;
  }
</style>
<script>
import Vue from "vue";
import Position from "@/components/position/position";
import {getRecruitPositionList} from '@/api/recruit'
import {getPositionTags, getPositionStatistics} from '@/api/positions'
import NoData from "@/components/noData";
import { hhLogo } from "@/common/utils/share-img";


export default {
  name: "recurit-detail-module",
  data(){
    return{
      id: this.$route.params.id,
      startTime: (this.$route.query.s) || 0,
      endTime:(this.$route.query.e) || 0,
      diffDay:(this.$route.query.d * 1) || 0,
      list: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      imgPath: "",
      isDownLoading: false//控制下拉刷新的加载动画
    };
  },
  components: {
    Position, NoData
  },
  methods: {
    //下拉刷新
    onDownRefresh() {
      this.pageNo = 1;
      this.finished = false;
      this.isDownLoading = true;
      this.onLoad(); //加载数据
    },
    
    onLoad() {
      let params = {pageNo:this.pageNo, pageSize: this.pageSize, type: 1};

      getRecruitPositionList(this.id,params).then(res=>{
        if(res&&res.data&&res.data.recruitSpecialLogoPath){
          this.imgPath = res.data.recruitSpecialLogoPath;
        }
        let curIds = [];
        if(res&&res.data&&res.data.list){
          curIds = res.data.list.map(item=>item.positionId) || [];

          res.data.list.forEach(item=>{
            item.positionTags = [];
            item.statics = {};
          })

          if(this.pageNo ==1){
            this.list = res.data.list;
          }else{
            this.list = this.list.concat(res.data.list);
          }

          if(res.data.list.length < this.pageSize){
            //最后一页不足10条
            this.finished = true;
          }else{
            this.pageNo++;
          }
        }else{
          //加载结束
          this.finished = true;
        }

        if(curIds && curIds.length){
          this.positionTags(curIds);
          this.positionStatistics(curIds);
        }
        console.log('设置微信123')
        this.$store.commit('comp/WX_SHARE',{
          title:'猎上活动 - ' + res.data.recruitSpecialName,
          desc:this.startTime + '至' + this.endTime + (this.diffDay > 0?(' 距活动结束还有' +this.diffDay+ '天'):''),
          imgUrl:res.data.recruitSpecialLogoPath || hhLogo
        });

      }).catch( err => {
        console.log(err,'err');
      }).finally(() => {
        this.isDownLoading = false;
        this.loading = false;
      });
    },
    positionTags(curIds){
      getPositionTags({positionIds: curIds.join(',')}).then(res=>{
        if(res&&res.data){
          this.list.forEach(item=>{
            if(res.data[item.positionId]){
              item.positionTags = res.data[item.positionId];  
            }
          });
        }
      }).catch(err=>{})
    },
    positionStatistics(curIds){
      getPositionStatistics({positionIds: curIds.join(',')}).then(res=>{
        if(res&&res.data){
          this.list.forEach(item=>{
            if(res.data[item.positionId]){
              item.statics = res.data[item.positionId];  
            }
          });
        }
      }).catch(err=>{})
    }
  },
  watch: {
    $route(n,o){
      this.list = [];
      this.pageNo = 1;
      this.finished = false;
      this.loading = true;
      this.onLoad();
    }
  },
  created() {
    this.loading = true;
    this.onLoad();
    
  }
};
</script>
